export default "/images/vendor/flag-icon-css/flags/1x1/zw.svg?2840e62aaca37d36b327f560b9557df1";